var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-base-toolbar',{attrs:{"title":"Reglas para atributos"},on:{"toggle-sidebar":_vm.toggleSidebar}},[_c('v-slide-x-transition',[(_vm.itemsTotal)?_c('v-toolbar-title',[_vm._v(_vm._s(_vm.itemsTotal)+" Matching Items")]):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }